import React, { useState } from 'react';
import './FAQs.css';

const FAQs: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="faqs">
      <div className="faqs-header">
        <h1>FAQs</h1>
        <p>Got questions? We've got you ♡</p>
      </div>

      <div className="container">
        <div className="faqs-content">
          <div className={`faq-item ${openFAQ === 0 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(0)}>
              <h3>✮ When will my order ship?</h3>
              <span className="faq-toggle">{openFAQ === 0 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Orders are usually processed and shipped within 2 to 7 business days, and you'll receive a confirmation email with tracking as soon as your package is on its way.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 1 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(1)}>
              <h3>✮ How much is shipping?</h3>
              <span className="faq-toggle">{openFAQ === 1 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <ul>
                <li><strong>Greece:</strong> €3 (Box Now or ELTA), delivery in 3 to 5 business days, free shipping on orders over €50</li>
                <li><strong>Cyprus:</strong> €7 (Box Now), €10 (ELTA), delivery in 3 to 7 business days, free shipping on orders over €80</li>
                <li><strong>Europe and USA:</strong> From €15 (up to 0.5kg) to €30 (over 1kg), approx. 14 business days</li>
                <li><strong>Rest of the world:</strong> Same as above, delivery time may vary depending on customs</li>
              </ul>
              <p><a href="/shipping">Full details on our Shipping Policy</a></p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 2 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(2)}>
              <h3>✮ Do you accept returns?</h3>
              <span className="faq-toggle">{openFAQ === 2 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>We currently do not accept returns, but we do offer exchanges within 10 business days of delivery, either by shipping the item back (customer covers shipping) or by visiting our physical store in Thessaloniki.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 3 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(3)}>
              <h3>✮ How do I exchange an item?</h3>
              <span className="faq-toggle">{openFAQ === 3 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Email us at <a href="mailto:eco.fashion.living@gmail.com">eco.fashion.living@gmail.com</a> or DM us on Instagram <a href="https://instagram.com/eco.fashion.living" target="_blank" rel="noopener noreferrer">@eco.fashion.living</a> with your order number, and we'll guide you through the process.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 4 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(4)}>
              <h3>✮ Are your vintage pieces authentic?</h3>
              <span className="faq-toggle">{openFAQ === 4 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Yes, all branded and designer pieces are authentically sourced and carefully inspected. We also carry deadstock vintage and reworked designs, all curated and created in-house.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 5 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(5)}>
              <h3>✮ Are your items one of a kind?</h3>
              <span className="faq-toggle">{openFAQ === 5 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Most of our pieces are one of a kind, carefully selected for their uniqueness. However, some items come from old boutiques and may have a small stock available, which is usually very limited and rare.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 6 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(6)}>
              <h3>✮ Do you restock items?</h3>
              <span className="faq-toggle">{openFAQ === 6 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Because many items are unique, we generally do not restock exact pieces. But we are always sourcing fresh vintage and deadstock gems, so keep an eye out for new arrivals.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 7 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(7)}>
              <h3>✮ Can I reserve an item?</h3>
              <span className="faq-toggle">{openFAQ === 7 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Currently, we do not offer reservations. Items are sold on a first-come, first-served basis.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 8 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(8)}>
              <h3>✮ How can I be sure the sunglasses are legit?</h3>
              <span className="faq-toggle">{openFAQ === 8 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>We understand there are many knock-offs on the market, so this concern is completely normal. All our eyewear includes a serial number on the frame, which you can verify online. Most of the time, you will find matching or very similar listings that confirm their authenticity.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 9 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(9)}>
              <h3>✮ Can I customize the lenses in your branded and designer glasses?</h3>
              <span className="faq-toggle">{openFAQ === 9 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>Yes, our glasses come with demo (non-prescription) lenses. You can easily take the frames to your optician to fit them with prescription lenses or tinted shades, whichever suits your style and needs.</p>
            </div>
          </div>

          <div className={`faq-item ${openFAQ === 10 ? 'open' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(10)}>
              <h3>✮ Where is your store located?</h3>
              <span className="faq-toggle">{openFAQ === 10 ? '−' : '+'}</span>
            </div>
            <div className="faq-answer">
              <p>We are in Thessaloniki city center, right across from Agora Modiano, just one minute from Aristotelous Square. You can find us on the 5th floor of a hidden arcade (στοά).</p>
              <p>Need help finding us? Check the directions on our <a href="/space">Visit Our Space</a> page.</p>
            </div>
          </div>

          <div className="faq-item final-cta">
            <h3>✮ Still have questions? ✮</h3>
            <p>We're here for you!</p>
            <p>Feel free to reach out at <a href="mailto:eco.fashion.living@gmail.com">eco.fashion.living@gmail.com</a> or DM us on Instagram <a href="https://instagram.com/eco.fashion.living" target="_blank" rel="noopener noreferrer">@eco.fashion.living</a> we're always happy to help ♡</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;